/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JsonConfiguration
 */
export interface JsonConfiguration {
    /**
     * 
     * @type {Date}
     * @memberof JsonConfiguration
     */
    today?: Date;
}

export function JsonConfigurationFromJSON(json: any): JsonConfiguration {
    return JsonConfigurationFromJSONTyped(json, false);
}

export function JsonConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'today': !exists(json, 'today') ? undefined : (new Date(json['today'])),
    };
}

export function JsonConfigurationToJSON(value?: JsonConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'today': value.today === undefined ? undefined : (value.today.toISOString().substr(0,10)),
    };
}

